/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetPostEngagementChartParams,
  SearchPostsParams,
  SuccessResponseDTOAdminPostManagerDetailResponseDTO,
  SuccessResponseDTOListEngagementResponseChartDTO,
  SuccessResponseDTOPageResponsePostManagerResponseDTO,
  SuccessResponseDTOVoid,
  UpdatePostStatusParams,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Update post status
 */
export const updatePostStatus = (postId: number, params: UpdatePostStatusParams) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/post-manager/${postId}/status`,
    method: 'PUT',
    params,
  });
};

export const getUpdatePostStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePostStatus>>,
    TError,
    { postId: number; params: UpdatePostStatusParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePostStatus>>,
  TError,
  { postId: number; params: UpdatePostStatusParams },
  TContext
> => {
  const mutationKey = ['updatePostStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePostStatus>>,
    { postId: number; params: UpdatePostStatusParams }
  > = (props) => {
    const { postId, params } = props ?? {};

    return updatePostStatus(postId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePostStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePostStatus>>
>;

export type UpdatePostStatusMutationError = unknown;

/**
 * @summary Update post status
 */
export const useUpdatePostStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePostStatus>>,
      TError,
      { postId: number; params: UpdatePostStatusParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePostStatus>>,
  TError,
  { postId: number; params: UpdatePostStatusParams },
  TContext
> => {
  const mutationOptions = getUpdatePostStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get post engagement chart data
 */
export const getPostEngagementChart = (
  postId: number,
  params: GetPostEngagementChartParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOListEngagementResponseChartDTO>({
    url: `/admin/api/post-manager/${postId}/engagement/chart`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetPostEngagementChartQueryKey = (
  postId?: number,
  params?: GetPostEngagementChartParams,
) => {
  return [
    `/admin/api/post-manager/${postId}/engagement/chart`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPostEngagementChartQueryOptions = <
  TData = Awaited<ReturnType<typeof getPostEngagementChart>>,
  TError = unknown,
>(
  postId: number,
  params: GetPostEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPostEngagementChart>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostEngagementChartQueryKey(postId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostEngagementChart>>> = ({ signal }) =>
    getPostEngagementChart(postId, params, signal);

  return { queryKey, queryFn, enabled: !!postId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPostEngagementChart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPostEngagementChartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPostEngagementChart>>
>;
export type GetPostEngagementChartQueryError = unknown;

export function useGetPostEngagementChart<
  TData = Awaited<ReturnType<typeof getPostEngagementChart>>,
  TError = unknown,
>(
  postId: number,
  params: GetPostEngagementChartParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPostEngagementChart>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostEngagementChart>>,
          TError,
          Awaited<ReturnType<typeof getPostEngagementChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPostEngagementChart<
  TData = Awaited<ReturnType<typeof getPostEngagementChart>>,
  TError = unknown,
>(
  postId: number,
  params: GetPostEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPostEngagementChart>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostEngagementChart>>,
          TError,
          Awaited<ReturnType<typeof getPostEngagementChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPostEngagementChart<
  TData = Awaited<ReturnType<typeof getPostEngagementChart>>,
  TError = unknown,
>(
  postId: number,
  params: GetPostEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPostEngagementChart>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get post engagement chart data
 */

export function useGetPostEngagementChart<
  TData = Awaited<ReturnType<typeof getPostEngagementChart>>,
  TError = unknown,
>(
  postId: number,
  params: GetPostEngagementChartParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPostEngagementChart>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPostEngagementChartQueryOptions(postId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary View post detail
 */
export const getPostDetail = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOAdminPostManagerDetailResponseDTO>({
    url: `/admin/api/post-manager/view-detail/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetPostDetailQueryKey = (id?: number) => {
  return [`/admin/api/post-manager/view-detail/${id}`] as const;
};

export const getGetPostDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getPostDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostDetail>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPostDetail>>> = ({ signal }) =>
    getPostDetail(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPostDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPostDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getPostDetail>>>;
export type GetPostDetailQueryError = unknown;

export function useGetPostDetail<
  TData = Awaited<ReturnType<typeof getPostDetail>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostDetail>>,
          TError,
          Awaited<ReturnType<typeof getPostDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPostDetail<
  TData = Awaited<ReturnType<typeof getPostDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPostDetail>>,
          TError,
          Awaited<ReturnType<typeof getPostDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPostDetail<
  TData = Awaited<ReturnType<typeof getPostDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary View post detail
 */

export function useGetPostDetail<
  TData = Awaited<ReturnType<typeof getPostDetail>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPostDetail>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPostDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search posts
 */
export const searchPosts = (params: SearchPostsParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOPageResponsePostManagerResponseDTO>({
    url: `/admin/api/post-manager/search`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getSearchPostsQueryKey = (params?: SearchPostsParams) => {
  return [`/admin/api/post-manager/search`, ...(params ? [params] : [])] as const;
};

export const getSearchPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchPosts>>,
  TError = unknown,
>(
  params: SearchPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPosts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchPosts>>> = ({ signal }) =>
    searchPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchPostsQueryResult = NonNullable<Awaited<ReturnType<typeof searchPosts>>>;
export type SearchPostsQueryError = unknown;

export function useSearchPosts<TData = Awaited<ReturnType<typeof searchPosts>>, TError = unknown>(
  params: SearchPostsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPosts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPosts>>,
          TError,
          Awaited<ReturnType<typeof searchPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchPosts<TData = Awaited<ReturnType<typeof searchPosts>>, TError = unknown>(
  params: SearchPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPosts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchPosts>>,
          TError,
          Awaited<ReturnType<typeof searchPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchPosts<TData = Awaited<ReturnType<typeof searchPosts>>, TError = unknown>(
  params: SearchPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPosts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search posts
 */

export function useSearchPosts<TData = Awaited<ReturnType<typeof searchPosts>>, TError = unknown>(
  params: SearchPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchPosts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchPostsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete live stream
 */
export const deleteLive = (liveId: string) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/post-manager/live/${liveId}`,
    method: 'DELETE',
  });
};

export const getDeleteLiveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLive>>,
    TError,
    { liveId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLive>>,
  TError,
  { liveId: string },
  TContext
> => {
  const mutationKey = ['deleteLive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLive>>, { liveId: string }> = (
    props,
  ) => {
    const { liveId } = props ?? {};

    return deleteLive(liveId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLiveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLive>>>;

export type DeleteLiveMutationError = unknown;

/**
 * @summary Delete live stream
 */
export const useDeleteLive = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLive>>,
      TError,
      { liveId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLive>>,
  TError,
  { liveId: string },
  TContext
> => {
  const mutationOptions = getDeleteLiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
